<template>
  <div class="page-home">
    <AnimBg id="page-bg" />
    <div id="top-bar">
      <span id="service-btn" @click="onServiceClick">充值/客服</span>
    </div>
    <div id="content">
      <SloganCircle id="slogan" />
    </div>
    <div v-if="invitationCode" @click="onCopyClick" id="invite">
      <span style="color: #eee;font-size: 14px;">邀请码</span>&nbsp;<span style="color: #eee;">{{ invitationCode
        }}</span>&nbsp;
      <svg width="14px" height="14px" viewBox="0 -960 960 960" fill="#eee">
        <path
          d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z" />
      </svg>
    </div>
    <div id="btn-download" @click="onDownloadClick">下载安装</div>
  </div>

  <Teleport to="body">
    <div v-if="isShowIosGuide" class="modal">
      <p>Hello from the modal!</p>
      <button @click="isShowIosGuide = false">Close</button>
    </div>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { useClipboard } from '@vueuse/core'
import usePlatform from '@/utils/usePlatform'
import useDownload from '@/utils/useDownload'
import SloganCircle from '@/components/SloganCircle.vue';
import AnimBg from '@/components/AnimBg.vue';
import { toast } from 'vue3-toastify';
// import axios from 'axios';
import 'vue3-toastify/dist/index.css';

const route = useRoute();
const { isIOS, isAndroid } = usePlatform();
const { copy } = useClipboard();
const { download } = useDownload();

// const androidUrl = ref(null);
// const iosUrl = ref(null);

// const canDownload = computed(()=>androidUrl.value !== null && iosUrl.value !== null);

// const fetchDownloadUrl = async () => {
//   try{
//     androidUrl.value = await axios.post('http://api.fishparty.top/www/app-version/download-url/1');
//     iosUrl.value = await axios.post('http://api.fishparty.top/www/app-version/download-url/2');
//   }catch(e){
//     print(e);
//   }
//   print(androidUrl.value);
//   print(iosUrl.value);
// }

// onMounted(()=>{
//   fetchDownloadUrl();
// })

const invitationCode = route.query.invitationCode;

const isShowIosGuide = ref(false);

// if (isIOS()) {
//   window.location.replace("https://jewge.hfhmyiow.com/api/c/iaffmzam");
// }

const onServiceClick = async () => {
  window.open("https://kmk-0266.jdlink.click", '_blank');
}

const onDownloadClick = () => {
  if (isIOS()) {
    window.open('https://sbasq.vzcpabgb.com/api/c/3s7gfed0', '_blank');
    // download('http://121.199.165.57:8888/apk/yuyu-last.ipa', 'yuyu.ipa');
  } else if (isAndroid()) {
    download('http://fish-apk.oss-cn-hongkong.aliyuncs.com/yuyu-app-1.0.1.03.apk', 'yuyu.apk');
  } else {
    toast("请使用手机下载", {
      autoClose: 1000,
    });
  }
  isShowIosGuide.value = true;
}

const onCopyClick = async () => {
  await copy(invitationCode);
  toast("已复制📋  请在APP内填入", {
    autoClose: 1000,
  });
}

</script>

<style lang="css" scoped>
.page-home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

#page-bg {
  position: absolute;
  width: 100vw;
  height: 100vh;
  /* background-color: #333; */
  /* z-index: 10; */
}

#top-bar {
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding: 12px;
}

#content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

#service-btn {
  padding: 4px 8px;
  border-radius: 100px;
  border: solid 1px;
  color: #eee;
  font-size: 0.8rem;
  font-weight: 400;
  z-index: 10;
}

#slogan {
  margin-bottom: 10vh;
}

#invite {
  margin: 12px;
  color: #eee;
  font-size: 1rem;
  font-weight: 400;
  z-index: 10;
}

#btn-download {
  margin-inline: 15vw;
  margin-bottom: 12vh;
  padding-block: 12px;
  border-radius: 100px;
  background: linear-gradient(20deg, rgb(144, 73, 243), rgb(89, 62, 243), rgb(71, 188, 250));
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  filter: drop-shadow(0px 2px 4px #3333335b);
}

.toast {
  background-color: blue;
  height: 400px;
}
</style>